const ourclientobj = [
        {
            id: 1,
            link1: "https://www.hellozindagi.co/",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/hello-zindagi.webp",
            img1: "assets/img/our-client/new_banners/hello-zindagi.webp",
            img2: "assets/img/our-client/hello-zindagi-2.webp",
            // img3: "assets/img/our-client/hp.webp",
            img3: "assets/img/our-client/new_banners/hp.webp",
            img4: "assets/img/our-client/hp-2.webp",
            // img5: "assets/img/our-client/hdfc.webp",
            img5: "assets/img/our-client/new_banners/hdfc.webp",
            img6: "assets/img/our-client/hdfc.webp",
        },
        {
            id: 2,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/tms.webp",
            img1: "assets/img/our-client/new_banners/tms.webp",
            img2: "assets/img/our-client/tms-2.webp",
            // img3: "assets/img/our-client/loserv.webp",
            img3: "assets/img/our-client/new_banners/loserv.webp",
            img4: "assets/img/our-client/loserve.webp",
            // img5: "assets/img/our-client/chatbot.webp",
            img5: "assets/img/our-client/new_banners/chatbot.webp",
            img6: "assets/img/our-client/chatbot-2.webp",
        },
        {
            id: 3,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/dental.webp",
            img1: "assets/img/our-client/new_banners/dental.webp",
            img2: "assets/img/our-client/dental-2.webp",
            // img3: "assets/img/our-client/heka.webp",
            img3: "assets/img/our-client/new_banners/heka.webp",
            img4: "assets/img/our-client/heka-2.webp",
            // img5: "assets/img/our-client/roadside.webp",
            img5: "assets/img/our-client/new_banners/roadside.webp",
            img6: "assets/img/our-client/roadside-2.webp",
        },
        {
            id: 4,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/early-morning.webp",
            img1: "assets/img/our-client/new_banners/early-morning.webp",
            img2: "assets/img/our-client/early-morning-2.webp",
            // img3: "assets/img/our-client/bluetooth.webp",
            img3: "assets/img/our-client/new_banners/bluetooth.webp",
            img4: "assets/img/our-client/bluetooth-2.webp",
            // img5: "assets/img/our-client/eskar.webp",
            img5: "assets/img/our-client/new_banners/eskar.webp",
            img6: "assets/img/our-client/eskar-2.webp",
        },
        {
            id: 5,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/she-burger.webp",
            img1: "assets/img/our-client/new_banners/she-burger.webp",
            img2: "assets/img/our-client/she-burger-2.webp",
            // img3: "assets/img/our-client/krista.webp",
            img3: "assets/img/our-client/new_banners/krista.webp",
            img4: "assets/img/our-client/krista-2.webp",
            // img5: "assets/img/our-client/smihaf.webp",
            img5: "assets/img/our-client/new_banners/smihaf.webp",
            img6: "assets/img/our-client/smihaf-2.webp",
        },
        {
            id: 6,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/anju-gupta.webp",
            img1: "assets/img/our-client/new_banners/anju-gupta.webp",
            img2: "assets/img/our-client/anju-gupta-2.webp",
            // img3: "assets/img/our-client/dealwy.webp",
            img3: "assets/img/our-client/new_banners/dealwy.webp",
            img4: "assets/img/our-client/dealwy-2.webp",
            // img5: "assets/img/our-client/career-helm.webp",
            img5: "assets/img/our-client/new_banners/career-helm.webp",
            img6: "assets/img/our-client/career-helm-2.webp",
        },
        {
            id: 7,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/plant.webp",
            img1: "assets/img/our-client/new_banners/plant.webp",
            img2: "assets/img/our-client/plant-2.webp",
            // img3: "assets/img/our-client/16-digit.webp",
            img3: "assets/img/our-client/new_banners/16-digit.webp",
            img4: "assets/img/our-client/16-digit-2.webp",
            // img5: "assets/img/our-client/tripbel.webp",
            img5: "assets/img/our-client/new_banners/tripbel.webp",
            img6: "assets/img/our-client/tripbel-2.webp",
        },
        {
            id: 8,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/nova.webp",
            img1: "assets/img/our-client/new_banners/nova.webp",
            img2: "assets/img/our-client/nova-2.webp",
            // img3: "assets/img/our-client/wotah.webp",
            img3: "assets/img/our-client/new_banners/wotah.webp",
            img4: "assets/img/our-client/wotah-2.webp",
            // img5: "assets/img/our-client/sansad.webp",
            img5: "assets/img/our-client/new_banners/sansad.webp",
            img6: "assets/img/our-client/sansad-2.webp",
        },
        {
            id: 9,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/sai.webp",
            img1: "assets/img/our-client/new_banners/sai.webp",
            img2: "assets/img/our-client/sai-2.webp",
            // img3: "assets/img/our-client/trex.webp",
            img3: "assets/img/our-client/new_banners/trex.webp",
            img4: "assets/img/our-client/trex-2.webp",
            // img5: "assets/img/our-client/lenskart.webp",
            img5: "assets/img/our-client/new_banners/lenskart.webp",
            img6: "assets/img/our-client/lenskart-2.webp",
        },
        {
            id: 10,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/pmg.webp",
            img1: "assets/img/our-client/new_banners/pmg.webp",
            img2: "assets/img/our-client/pmg-2.webp",
            // img3: "assets/img/our-client/loserve.webp",
            img3: "assets/img/our-client/new_banners/loserv.webp",
            img4: "assets/img/our-client/loserve-2.webp",
            // img5: "assets/img/our-client/saidham.webp",
            img5: "assets/img/our-client/new_banners/saidham.webp",
            img6: "assets/img/our-client/saidham-2.webp",
        },
        {
            id: 11,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/usha.webp",
            img1: "assets/img/our-client/new_banners/usha.webp",
            img2: "assets/img/our-client/usha-2.webp",
            // img3: "assets/img/our-client/renault.webp",
            img3: "assets/img/our-client/new_banners/renault.webp",
            img4: "assets/img/our-client/renault-2.webp",
            // img5: "assets/img/our-client/ccm.webp",
            img5: "assets/img/our-client/new_banners/ccm.webp",
            img6: "assets/img/our-client/ccm-2.webp",
        },
        {
            id: 12,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/clm.webp",
            img1: "assets/img/our-client/new_banners/clm.webp",
            img2: "assets/img/our-client/clm-2.webp",
            // img3: "assets/img/our-client/safe-zone.webp",
            img3: "assets/img/our-client/new_banners/safe-zone.webp",
            img4: "assets/img/our-client/safe-zone-2.webp",
            // img5: "assets/img/our-client/ereda.webp",
            img5: "assets/img/our-client/new_banners/ereda.webp",
            img6: "assets/img/our-client/ereda-2.webp",
        },
        {
            id: 13,
            link1: "/contact-us",
            link2: "/contact-us",
            link3: "/contact-us",
            // img1: "assets/img/our-client/deloitte.webp",
            img1: "assets/img/our-client/new_banners/deloitte.webp",
            img2: "assets/img/our-client/deloitte-2.webp",
            // img3: "assets/img/our-client/smart-brains.webp",
            img3: "assets/img/our-client/new_banners/smart-brains.webp",
            img4: "assets/img/our-client/smart-brains-2.webp",
            // img5: "assets/img/our-client/phadi.webp",
            img5: "assets/img/our-client/new_banners/phadi.webp",
            img6: "assets/img/our-client/phadi42.webp",
        },
        // {
        //     id: 14,
        //     link1: "/contact-us",
        //     link2: "/contact-us",
        //     link3: "/contact-us",
        //     // img1: "assets/img/our-client/deloitte.webp",
        //     img1: "assets/img/our-client/new_banners/deloitte.webp",
        //     img2: "assets/img/our-client/deloitte-2.webp",
        //     // img3: "assets/img/our-client/smart-brains.webp",
        //     img3: "assets/img/our-client/new_banners/smart-brains.webp",
        //     img4: "assets/img/our-client/smart-brains-2.webp",
        //     // img5: "assets/img/our-client/phadi.webp",
        //     img5: "assets/img/our-client/new_banners/phadi.webp",
        //     img6: "assets/img/our-client/phadi42.webp",
        // },
    ]
export default ourclientobj;